import { DataView, Pagination, TableColumn, csx } from '@vtex/admin-ui'
import { useEffect } from 'react'
import type { DefaultProps, SimplifiedPromotion } from 'typings'
import { usePromotionsListState } from '../usePromotionsListState'

interface TableProps extends DefaultProps {
  columns: Array<TableColumn<SimplifiedPromotion>>
}

export function Table(props: TableProps) {
  const { columns, children } = props
  const { viewState, setColumns, paginationState } = usePromotionsListState()

  useEffect(() => {
    setColumns(columns)
  }, [columns, setColumns])

  return (
    <>
      <DataView state={viewState} className={csx({ paddingTop: '$space-2' })}>
        {children}
      </DataView>

      <Pagination
        state={paginationState}
        className={csx({
          float: 'right',
          marginY: '$space-5',
          display: paginationState.nextDisabled ? 'none' : 'unset',
        })}
      />
    </>
  )
}
